/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Amazon Redshift integration configuration
*/
export class RedshiftIntegrationConfig {
  /**
  * Restore account ID
  */
  'restoreAccountId'?: string;
  'region'?: string;
  'clusterIdentifier'?: string;
  'database'?: string | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "clusterIdentifier",
      "baseName": "clusterIdentifier",
      "type": "string",
      "format": ""
    },
    {
      "name": "database",
      "baseName": "database",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RedshiftIntegrationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

